























import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import GSchoolClassBulkMoveModal from '@/views/GSchoolClassChange/GSchoolClassBulkMoveModal.vue';
import { GEnum } from '@/constants/enum.defination';
import { schoolClassChangeModule } from '@/store/modules/frames/school-class-change.module';
import { StudentsByClass } from '@/models/student/students-by-class';
import { StudentDraggableExtraArea } from '@/models/student/student-draggable-extra-area';
import { Student } from '@/models/student/student';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GSchoolClassChangeToolBar',
  components: { GSchoolClassBulkMoveModal },
  computed: {},
  methods: {},
})
export default class GSchoolClassChangeToolBar extends Mixins(GPageBase) {
  isReverse: boolean = false;
  @Prop() dragAreaType: GEnum.DragAreaType;
  @Prop({ default: () => {} }) studentsBySchoolClass: StudentsByClass;
  mounted() {}

  get isDragAreaTypeSchoolClass(): boolean {
    return this.dragAreaType === GEnum.DragAreaType.TypeSchoolClass;
  }

  get isDragAreaTypeSDeleteSpace(): boolean {
    return this.dragAreaType === GEnum.DragAreaType.TypeDeleteSpace;
  }

  // 空の時は非表示
  get disableSortButton(): boolean {
    switch (this.dragAreaType) {
      case GEnum.DragAreaType.TypeSchoolClass:
        return this.studentsBySchoolClass.students.length === 0;
      case GEnum.DragAreaType.TypeDeleteSpace:
        return this.studentDraggableExtraArea.deleteStudents.length === 0;
      case GEnum.DragAreaType.TypeWorkSpace:
        return this.studentDraggableExtraArea.noAssignStudents.length === 0;
    }
  }

  // 空の時は非表示
  get disableMoveButton(): boolean {
    switch (this.dragAreaType) {
      case GEnum.DragAreaType.TypeSchoolClass:
        return this.studentsBySchoolClass.students.length === 0 || this.studentsBySchoolClass.students.every((student: Student) => student.checked);
      case GEnum.DragAreaType.TypeDeleteSpace:
        return this.studentDraggableExtraArea.deleteStudents.length === 0 || this.studentDraggableExtraArea.deleteStudents.every((student: Student) => student.checked);
      case GEnum.DragAreaType.TypeWorkSpace:
        return this.studentDraggableExtraArea.noAssignStudents.length === 0;
    }
  }

  get studentDraggableExtraArea(): StudentDraggableExtraArea {
    return schoolClassChangeModule.studentDraggableExtraArea;
  }

  get studentShowMode(): boolean {
    return schoolClassChangeModule.studentShowMode;
  }

  handleAllLockButton() {
    switch (this.dragAreaType) {
      case GEnum.DragAreaType.TypeSchoolClass:
        this.studentsBySchoolClass.students = this.studentsBySchoolClass.students.map((student: Student) => {
          student.checked = true;
          return student;
        });
        break;
      case GEnum.DragAreaType.TypeDeleteSpace:
        this.studentDraggableExtraArea.deleteStudents = this.studentDraggableExtraArea.deleteStudents.map((student: Student) => {
          student.checked = true;
          return student;
        });
        break;
    }
  }

  handleAllUnlockButton() {
    switch (this.dragAreaType) {
      case GEnum.DragAreaType.TypeSchoolClass:
        this.studentsBySchoolClass.students = this.studentsBySchoolClass.students.map((student: Student) => {
          student.checked = false;
          return student;
        });
        break;
      case GEnum.DragAreaType.TypeDeleteSpace:
        this.studentDraggableExtraArea.deleteStudents = this.studentDraggableExtraArea.deleteStudents.map((student: Student) => {
          student.checked = false;
          return student;
        });
        break;
    }
  }

  // 各D&D領域におけるソート
  handleClickSortButton() {
    switch (this.dragAreaType) {
      case GEnum.DragAreaType.TypeSchoolClass:
        this.studentsBySchoolClass.students = this.studentsBySchoolClass.students.sort(this.sortStudents(this.isReverse));
        break;
      case GEnum.DragAreaType.TypeDeleteSpace:
        this.studentDraggableExtraArea.deleteStudents = this.studentDraggableExtraArea.deleteStudents.sort(this.sortStudents(this.isReverse));
        break;
      case GEnum.DragAreaType.TypeWorkSpace:
        this.studentDraggableExtraArea.noAssignStudents1 = this.studentDraggableExtraArea.noAssignStudents1.sort(this.sortStudents(this.isReverse));
        this.studentDraggableExtraArea.noAssignStudents2 = this.studentDraggableExtraArea.noAssignStudents2.sort(this.sortStudents(this.isReverse));
        this.studentDraggableExtraArea.noAssignStudents3 = this.studentDraggableExtraArea.noAssignStudents3.sort(this.sortStudents(this.isReverse));
        this.studentDraggableExtraArea.noAssignStudents4 = this.studentDraggableExtraArea.noAssignStudents4.sort(this.sortStudents(this.isReverse));
        break;
    }
    this.isReverse = !this.isReverse;
  }

  // 一括移動モーダル起動時の表示設定
  handleClickBulkMoveButton() {
    schoolClassChangeModule.setClickDragAreaType(this.dragAreaType);
    switch (this.dragAreaType) {
      case GEnum.DragAreaType.TypeSchoolClass:
        schoolClassChangeModule.setBulkStudents(this.cloneStudents(this.studentsBySchoolClass.students));
        schoolClassChangeModule.setFromName(this.studentsBySchoolClass.schoolClass.schoolClassName);
        schoolClassChangeModule.setFromSchoolClassID(this.studentsBySchoolClass.schoolClass.schoolClassID);
        break;
      case GEnum.DragAreaType.TypeDeleteSpace:
        schoolClassChangeModule.setBulkStudents(this.cloneStudents(this.studentDraggableExtraArea.deleteStudents));
        schoolClassChangeModule.setFromName(this.$t('TRANSFERRING_OR_WITHDRAWING_FROM_SCHOOL').toString());
        break;
      case GEnum.DragAreaType.TypeWorkSpace:
        schoolClassChangeModule.setBulkStudents(this.cloneStudents(this.studentDraggableExtraArea.noAssignStudents));
        schoolClassChangeModule.setFromName(this.$t('WORK_AREA').toString());
        break;
    }

    schoolClassChangeModule.setBulkStudents(schoolClassChangeModule.bulkStudents.sort((a: Student, b: Student) => (a.studentNumber > b.studentNumber ? 1 : -1)));

    setTimeout(() => {
      schoolClassChangeModule.setBulkMoveModal(true);
    }, 100);
  }

  cloneStudents(students: Student[]) {
    return students.map((student: Student) => new Student().deserialize(student));
  }

  sortStudents(isReverse: boolean) {
    return (a: Student, b: Student) => {
      let condition: boolean;
      if (this.studentShowMode) {
        condition = isReverse ? a.lastNameKana < b.lastNameKana : a.lastNameKana > b.lastNameKana;
      } else {
        condition = isReverse ? a.studentNumber < b.studentNumber : a.studentNumber > b.studentNumber;
      }
      if (condition) {
        return 1;
      } else {
        return -1;
      }
    };
  }
}
